import React from "react";
import _ from "lodash";
import InputMask from 'react-input-mask';
import {
  Input,
  Button,
  Select,
  Checkbox,
  Row,
  Col,
  Collapse,
  AutoComplete,
  InputNumber,
  Switch,
  Form,
} from "antd";


const { Panel } = Collapse;
const { Option } = Select;

class FormOne extends React.Component {
  state = {
    mockData: [],
    targetKeys: [],
  };

  handleChange = (targetKeys) => {
    this.setState({ targetKeys });
  };

  render() {
    const {
      formRef,
      onFinish,
      hmgMainGetData,
      userListGetData,
      solutionsGetData,
      autoCompleteOneChange,
      autoCompleteOneSelect,
      createStatus,
      current,
      next,
      prev,
      steps,
      solutionsRelatedToHMG,
      generateEntityID,
    } = this.props;


    const dataSource = hmgMainGetData.map((d) => {
      return { value: d.hmg_name };
    });

    const solutionsOptions = solutionsGetData.filter(
      solution => solutionsRelatedToHMG.includes(solution.solution_name)
    ).map((d) => (
      <Col span={8} key={d._id}>
        <Checkbox value={d._id} checked>{d.solution_name}</Checkbox>
      </Col>
    ));
    const userOptions = userListGetData.map((d) => (
      <Option key={d._id}>
        {" "}
        {d.name} - {d.user_name} - {d.email ? d.email : <b>No user email</b>}
      </Option>
    ));

    return (
      <div>
        {/* {console.log("render run")} */}
        <Collapse defaultActiveKey={["2_1"]} expandIconPosition="end">
          <Panel
            header={_.startCase(_.camelCase(steps[current].title))}
            key="2_1"
          >
            <Form
              ref={formRef}
              labelCol={{
                xs: { span: 24 },
                sm: { span: 6 },
                md: { span: 6 },
                lg: { span: 5 },
                xl: { span: 5 },
                xxl: { span: 5 },
              }}
              wrapperCol={{
                xs: { span: 24 },
                sm: { span: 18 },
                md: { span: 18 },
                lg: { span: 15 },
                xl: { span: 12 },
                xxl: { span: 12 },
              }}
              onFinish={onFinish}
              onKeyPress={(e) => (e.key === "Enter" ? e.preventDefault() : "")}
            >
              <Form.Item name="_id" label="Id" style={{ display: "none" }}>
                <Input />
              </Form.Item>
              <div
                style={
                  current === 0 ? { display: "block" } : { display: "none" }
                }
              >
                <Form.Item
                  name="hmg_name_1"
                  label="Hotel Management Group"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Hotel Management Group",
                    },
                  ]}
                >
                  <AutoComplete
                    options={dataSource}
                    placeholder="Enter Hotel Management Group"
                    filterOption={(inputValue, option) =>
                      option.value
                        .toUpperCase()
                        .indexOf(inputValue.toUpperCase()) !== -1
                    }
                    onChange={autoCompleteOneChange}
                    onSelect={autoCompleteOneSelect}
                    allowClear={true}
                  />
                </Form.Item>

                <div
                  className="is_animation_1"
                  style={
                    createStatus ? { maxHeight: "0" } : { maxHeight: "100px" }
                  }
                >
                  <Form.Item
                    name="hmg_name"
                    label="Rename HMG"
                    rules={[
                      {
                        required: true,
                        message:
                          "Please Enter Rename Hotel Management Group Name",
                      },
                    ]}
                  >
                    <Input placeholder="Enter Rename Hotel Management Group Name" />
                  </Form.Item>
                </div>

                <Form.Item name="solutions" label="Solutions">
                  <Checkbox.Group style={{ width: "100%" }}>
                    <Row>{solutionsOptions}</Row>
                  </Checkbox.Group>
                </Form.Item>

                <Form.Item
                  name="is_entityid"
                  label="Entity ID"
                  className="is-input-mask"
                  initialValue={generateEntityID(hmgMainGetData)}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Entity ID",
                    },
                  ]}
                >
                  <InputMask
                    mask="999999999"
                    placeholder="Enter numbers only"
                    className="ant-input"
                    maskChar={null}
                  />
                </Form.Item>

                {/* <Form.Item label="IS Admin Username">
                  {getFieldDecorator("is_admin_username")(
                    <Input placeholder="Enter IS Admin Username" />
                  )}
                </Form.Item>

                <Form.Item label="Admin Password">
                  {getFieldDecorator("is_admin_password")(
                    <Input placeholder="Enter Admin Password" />
                  )}
                </Form.Item> */}

                <Form.Item name="myp_id" label="MYP HMG ID">
                  <InputNumber
                    disabled={true}
                    style={{ width: "100%" }}
                    placeholder="MYP HMG ID"
                  />
                </Form.Item>

                <Form.Item
                  name="mdo_mgmtgroupemail"
                  label="MDO Mgmt Group Email"
                  rules={[
                    {
                      type: "email",
                      message: "Please Enter Valid Email",
                    },
                  ]}
                >
                  <Input placeholder="Enter MDO Mgmt Group Email" />
                </Form.Item>

                <Form.Item
                  name="mdo_mgmtgroupemailpassword"
                  label="MDO Mgmt Group Email Password"
                >
                  <Input placeholder="Enter MDO Mgmt Group Email Password" />
                </Form.Item>

                <Form.Item
                  name="smart_scan_type"
                  label="Smart Scan Type"
                  initialValue="0"
                >
                  <Select
                    placeholder="Enter Smart Scan Type"
                    showSearch
                    optionFilterProp="children"
                    notFoundContent={null}
                  >
                    {/* <Option value="2">Parent</Option> */}
                    <Option value="1">Yes</Option>
                    <Option value="0">No</Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  name="split_by_sub_header"
                  initialValue="0"
                  label="Split Reports By Sub Header Type"
                >
                  <Select
                    placeholder="Enter Split Reports By Sub Header Type"
                    showSearch
                    optionFilterProp="children"
                    notFoundContent={null}
                  >
                    <Option value="1">Yes</Option>
                    <Option value="0">No</Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  name="hmg_22"
                  label="V2.2 Hotel Management Group"
                  valuePropName="checked"
                  initialValue={true}
                >
                  <Switch />
                </Form.Item>
                <div
                  style={
                    process.env.REACT_APP_PLATFORM_TYPE &&
                    process.env.REACT_APP_PLATFORM_TYPE === "MARRIOTT"
                      ? { display: "none" }
                      : { display: "block" }
                  }
                >
                  <Form.Item
                    name="myp_create_or_update"
                    label="MYP Create Or Update"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter MYP Create Or Update",
                      },
                    ]}
                    initialValue="0"
                  >
                    <Select
                      showSearch
                      optionFilterProp="children"
                      placeholder="Enter MYP Create Or Update"
                    >
                      <Option value="1">Yes</Option>
                      <Option value="0">No</Option>
                    </Select>
                  </Form.Item>

                  <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, currentValues) =>
                      prevValues.myp_create_or_update !==
                      currentValues.myp_create_or_update
                    }
                  >
                    {({ getFieldValue }) =>
                      getFieldValue("myp_create_or_update") === "1" ? (
                        <Form.Item
                          name="myp_corporate_user"
                          label="MYP Corporate User"
                          rules={[
                            {
                              required:
                                getFieldValue("myp_create_or_update") === "1",
                              message: "Please Enter MYP Corporate User",
                            },
                          ]}
                        >
                          <Select
                            showSearch
                            disabled={
                              typeof getFieldValue("myp_id") === "number"
                            }
                            optionFilterProp="children"
                            placeholder="Enter MYP Create Or Update"
                          >
                            {userOptions}
                          </Select>
                        </Form.Item>
                      ) : null
                    }
                  </Form.Item>
                </div>
                <Form.Item
                  name="annotation"
                  label="Annotate After Signature"
                  valuePropName="checked"
                  initialValue={false}
                >
                  <Switch />
                </Form.Item>
                <Form.Item
                  name="mwf"
                  label="MWF"
                  valuePropName="checked"
                  initialValue={false}
                >
                  <Switch />
                </Form.Item>

                <Form.Item wrapperCol={{ span: 12, offset: 5 }}>
                  <Button type="primary" onClick={next}>
                    Next
                  </Button>
                </Form.Item>
              </div>

              <div
                style={
                  current === 1 ? { display: "block" } : { display: "none" }
                }
              >
                <Row>
                  <Col xs={24} sm={6} md={6} lg={5} xl={5} xxl={5}></Col>
                  <Col xs={24} sm={18} md={18} lg={15} xl={12} xxl={12}>
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "#333",
                        margin: "16px 0",
                        display: "block",
                      }}
                    >
                      CORPORATE CONTACT
                    </span>
                  </Col>
                </Row>

                <Form.Item name="corp_contact_name" label="Name">
                  <Input placeholder="Enter Name" />
                </Form.Item>

                <Form.Item name="corp_position_title" label="Position Title">
                  <Input placeholder="Enter Position Title" />
                </Form.Item>

                <Form.Item
                  name="corp_office_phone"
                  label="Office Phone"
                  initialValue=""
                  rules={[
                    {
                      pattern: new RegExp(/^___-___-____$|^\d{3}-\d{3}-\d{4}$/),
                      message: "Please enter a valid phone number",
                    },
                  ]}
                >
                  <InputMask
                    mask="999-999-9999"
                    placeholder="Enter Office Phone"
                    className="ant-input"
                  />
                </Form.Item>

                <Form.Item
                  name="corp_work_cell"
                  label="Work Cell"
                  initialValue=""
                  rules={[
                    {
                      pattern: new RegExp(/^___-___-____$|^\d{3}-\d{3}-\d{4}$/),
                      message: "Please enter a valid phone number",
                    },
                  ]}
                >
                  <InputMask
                    mask="999-999-9999"
                    placeholder="Enter Work Cell"
                    className="ant-input"
                  />
                </Form.Item>

                <Form.Item
                  name="corp_email"
                  label="Email"
                  rules={[
                    {
                      type: "email",
                      message: "Please Enter Valid Email",
                    },
                  ]}
                >
                  <Input placeholder="Enter Email" />
                </Form.Item>

                <Row>
                  <Col xs={24} sm={6} md={6} lg={5} xl={5} xxl={5}></Col>
                  <Col xs={24} sm={18} md={18} lg={15} xl={12} xxl={12}>
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "#333",
                        margin: "16px 0",
                        display: "block",
                      }}
                    >
                      CORPORATE ADDRESS
                    </span>
                  </Col>
                </Row>

                {/* <Divider orientation="left">CORPORATE ADDRESS</Divider> */}
                <Form.Item name="corp_address" label="Address">
                  <Input placeholder="Street/Building/PO Box Information" />
                </Form.Item>

                <Form.Item name="corp_city" label="City">
                  <Input placeholder="Enter City" />
                </Form.Item>

                <Form.Item name="country" label="Country">
                  <Select placeholder="Enter Country">
                    <Option value="United States">United States</Option>
                    <Option value="Canada">Canada</Option>
                  </Select>
                </Form.Item>

                <Form.Item name="state" label="State">
                  <Select placeholder="Enter State">
                    <Option value="al">AL</Option>
                    <Option value="ak">AK</Option>
                  </Select>
                </Form.Item>

                <Form.Item name="corp_zip" label="Zip">
                  <Input placeholder="Enter Zip" />
                </Form.Item>

                <Form.Item wrapperCol={{ span: 12, offset: 5 }}>
                  <Button onClick={prev} style={{ marginRight: 8 }}>
                    Previous
                  </Button>

                  <Button type="primary" htmlType="submit">
                    {createStatus ? "Create" : "Update"}
                  </Button>
                  {/* <Button type="primary" onClick={next}>
                    Next
                  </Button> */}
                </Form.Item>
              </div>
            </Form>
          </Panel>
        </Collapse>
      </div>
    );
  }
}

export default FormOne;
